/**
 * mediaUtils.js
 * Utility helpers for resolving image and video URLs across all CMS forms and preview dashboards.
 */

const getApiOrigin = () => {
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'https://permataharapansecondary.sch.id';
  }
  return '';
};

export const getImageUrl = (mediaId, mediaMap = {}) => {
  if (!mediaId) return null;

  // 1. Direct match in mediaMap
  if (mediaMap && typeof mediaMap === 'object') {
    if (mediaMap[mediaId]) return getImageUrl(mediaMap[mediaId]);
    if (mediaMap[String(mediaId)]) return getImageUrl(mediaMap[String(mediaId)]);
    const numId = Number(mediaId);
    if (!isNaN(numId) && mediaMap[numId]) return getImageUrl(mediaMap[numId]);
  }

  const mediaStr = String(mediaId).trim();
  if (!mediaStr) return null;

  // 2. Direct full URL or data URI
  if (mediaStr.startsWith('http://') || mediaStr.startsWith('https://') || mediaStr.startsWith('blob:') || mediaStr.startsWith('data:')) {
    return mediaStr;
  }

  const origin = getApiOrigin();

  // 3. Backend uploads path
  if (mediaStr.startsWith('/uploads/') && !mediaStr.startsWith('/api/uploads/')) {
    const apiPath = `/api${mediaStr}`;
    return origin ? `${origin}${apiPath}` : apiPath;
  }
  if (mediaStr.startsWith('/api/uploads/')) {
    return origin ? `${origin}${mediaStr}` : mediaStr;
  }
  if (mediaStr.startsWith('uploads/') || mediaStr.startsWith('api/uploads/')) {
    const p = mediaStr.startsWith('uploads/') ? `/api/${mediaStr}` : `/${mediaStr}`;
    return origin ? `${origin}${p}` : p;
  }

  // 4. Absolute path on domain
  if (mediaStr.startsWith('/')) {
    return mediaStr;
  }

  // 5. Filename with image extension
  if (/\.(jpg|jpeg|png|webp|svg|gif|avif)$/i.test(mediaStr)) {
    if (mediaStr.startsWith('cms_media_')) {
      return origin ? `${origin}/uploads/cms/${mediaStr}` : `/uploads/cms/${mediaStr}`;
    }
    if (mediaStr.startsWith('aboutus_')) {
      return origin ? `${origin}/api/uploads/homepage/about-us/${mediaStr}` : `/api/uploads/homepage/about-us/${mediaStr}`;
    }
    if (mediaStr.startsWith('media_')) {
      return origin ? `${origin}/api/uploads/homepage/highlights/${mediaStr}` : `/api/uploads/homepage/highlights/${mediaStr}`;
    }
    return origin ? `${origin}/api/uploads/images/${mediaStr}` : `/api/uploads/images/${mediaStr}`;
  }

  // 6. Filename with dot in general
  if (mediaStr.includes('.')) {
    return origin ? `${origin}/api/uploads/images/${mediaStr}` : `/api/uploads/images/${mediaStr}`;
  }

  return null;
};

export const getVideoUrl = (videoFile) => {
  if (!videoFile) return null;
  const videoStr = String(videoFile).trim();
  if (!videoStr) return null;

  // Fix legacy or broken /uploads/homepage/videos/ URLs to point to real physical upload location
  if (videoStr.includes('/uploads/homepage/videos/')) {
    const filename = videoStr.split('/uploads/homepage/videos/')[1];
    return `https://permataharapansecondary.sch.id/api/uploads/videos/${filename}`;
  }

  if (videoStr.startsWith('http://') || videoStr.startsWith('https://') || videoStr.startsWith('blob:') || videoStr.startsWith('data:')) {
    return videoStr;
  }

  if (videoStr.startsWith('/api/uploads/videos/')) {
    return `https://permataharapansecondary.sch.id${videoStr}`;
  }

  if (videoStr.startsWith('/uploads/videos/')) {
    return `https://permataharapansecondary.sch.id/api${videoStr}`;
  }

  if (videoStr.startsWith('/')) {
    return videoStr;
  }

  if (videoStr.startsWith('cms_media_')) {
    return `/uploads/cms/${videoStr}`;
  }

  return `https://permataharapansecondary.sch.id/api/uploads/videos/${videoStr}`;
};
